import { ct } from "../../constant-Utils";

export const infoMessages = {
  checkingSystem: "Checking system status...",
  checkingSystemInConference: "Please wait while system is checking...",
  internetDetecting: "Checking internet speed.",
  internetDetected: "Your internet speed is ",
  internetDetectFailed: "You have no internet connection.",
  interfaceDetecting: "Detecting RealTime Audio interface.",
  interfaceWorking: "RealTime Audio interface working.",
  microphoneStatus: "Your microphone is working properly.",
  microphoneStatusNot: "Your microphone is not working.",
  webcamStatus: "Your camera is working properly.",
  webcamStatusNot: "Your camera is not working.",
  deviceDetecting: "Detecting RealTime Audio device.",
  devicePairing: "Pairing with RealTime Audio device.",
  devicePaired: "Paired with RealTime Audio device.",
  connectConnectFailed: "RealTime Audio connect failed.",

  // deviceDetectFailed: "A RealTime Audio device has not been detected. If you would like to continue without ultra-low latency, click \"Join Meeting\".If you have a RealTime Audio device, make sure that the ethernet cable is connected directly between it and your router, that the audio interface is connected via the USB-3 port, and that the RTA device is plugged into the wall using the power adpapter provided and that it's lights are on. Then please try rebooting the device manually by disconnecting the power from the device and then plugging it back in.",
  deviceDetectFailed:
    'A RealTime Audio device has not been detected. If you would like to continue without ultra-low latency, click "Join Meeting". If you have a RealTime Audio device, please click on info icon to confirm settings.',
  audioNotAvailable: "Microphone is not available.",
  audioNotAllowed: "Microphone is not allowed.",
  audioMuted:
    "Please unmute your microphone if you'd like it enabled for your conference.",
  audioWorking: "Microphone is working properly.",

  videoNotAvailable: "Camera is not available.",
  videoNotAllowed: "Camera is not allowed.",
  videoMuted:
    "Please unmute your camera if you'd like it enabled for your conference.",
  videoWorking: "Your camera is working properly.",

  deviceFoundIssue:
    "RealTime Audio device detected with issue(s), please click on info icon to check issue(s)",
  selectSubscription:
    "Please select subscription plan to jam in real time with RealTime Audio device",
  deviceConnectNoAudio:
    "Paired with a RealTime Audio device. All audio communication will be through your audio interface. Your mic is now muted.",
  basic_subscription_not: "Basic subscription not found.",
  premium_subscription_not: "Premium Subscription not found.",
  basic_subscription: "Basic subscription found.",
  premium_subscription: "Premium Subscription found.",
  checking_basic_subscription: "Checking for active subscription...",
  deviceChangesDetected:
    "We have detected some changes on your RealTime Audio device, Please wait...",
  deviceReconnecting: "Checking your device compatibility is taking longer than usual, please wait...",
  deviceReconnectingFailed: "We are unable to check your device compatibility. Please wait while we are refreshing your conference.",
  deviceReconnectingFailedInConference: "We are unable to check your device compatibility. So please try again after sometime.",
};

export const deviceCodeChain = {
  INTERFACE: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "yes",
    "checking_interface"
  ], // interface not found
  REGISTER_DEVICE: [
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "no",
    "register_device"
  ], // register_device

  REGISTER_DEVICE_WAITING: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "no",
    "register_device",
    "yes"
  ],

  USER_HAVE_DEVICE: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "no",
    "register_device",
    "yes",
    "next_wait"
  ],

  REGISTER_DEVICE_INPUT: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "no",
    "register_device",
    "yes",
    "next_wait",
    "option",
    "yes",
    "device_input"
  ],

  REGISTER_DEVICE_INPUT_SHOW: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "no",
    "register_device",
    "yes",
    "next_wait",
    "option",
    "yes",
    "waiting"
  ],

  NO_DEVICE_REG: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "no",
    "register_device"
  ], // device not registered / my device is not found

  NET_PORT_ISSUE: ["light_on", "yes", "option", "step_a", "port_issue", "yes"], // network port issue

  PRIVATE_FIREWALL_ISSUE: ["light_on", "yes", "option", "step_b"], // network port issue
  DEFAULT: ["light_on"],

  BUFFER_ISSUE: [
    "light_on",
    "yes",
    "option",
    "step_a",
    "port_issue",
    "no",
    "non_premissive_net",
    "no",
    "detecting_device",
    "found_device",
    "my_device",
    "yes",
    "checking_interface",
    "yes",
    "buffer_issue",
    "yes"
  ],
  RTA_WEBCAM_NOT_WORKING: ["webcam"],
  RTA_MICROPHONE_NOT_WORKING: ["microphone"],
  ALL_SET: ["all_set"],
  UNKNOWN_ERROR: ["unknown_error"],
  UNKNOWN_ERROR_CONNECT: ["unknown_error_connect"],

  WAITING_DEVICE: ["socket_no_error_waiting", "waiting"],
  SUBSCRIPTION: ["subscription"],
  BASIC_SUBSCRIPTION: ["basic_subscription"],
  STEP_A_NO_YES_LIGHT: ["light_on", "no", "option", "yes", "waiting"],
  STEP_A_NO_NO_LIGHT: ["light_on", "no", "option", "no", "need_help"],
  STEP_C_YES: ["light_on", "yes", "option", "step_c"],
  STEP_A_YES_B_A: [
    "light_on",
    "yes",
    "option",
    "step_b",
    "option",
    "yes",
    "waiting"
  ],
  STEP_A_YES_B_B: [
    "light_on",
    "yes",
    "option",
    "step_b",
    "option",
    "no",
    "need_help"
  ],
  STEP_A_YES_C_A: [
    "light_on",
    "yes",
    "option",
    "step_c",
    "option",
    "yes",
    "waiting"
  ],
  STEP_A_YES_C_B: [
    "light_on",
    "yes",
    "option",
    "step_c",
    "option",
    "no",
    "need_help"
  ]
};

export const INFO_CODE = {
  NO_DEVICE_DETECT: "L-101", // no device detected initially
  R_VD_N_ALD: "J-101", // rta video not allowed or not found
  R_AD_N_ALD: "J-102", // rta video not allowed or not found
  R_NET_SPEED: "N-103", // rta speed testing
  NON_CAPBL_INTER: "N-101", // no compatible interface
  NO_INTER: "A-101", // no compatible interface
  PORT_ISSUE: "B-109", // no compatible interface
  REGISTER_DEVICE: "R-101",
  SYMMETRIC_NAT: "I-101", // port issue
  BUFFER_ISSUE: "B-108", // buffer issue
  PRIVATE_FIREWALL_ISSUE: "I-107",

  MICROPHONE_NOT_ALLOWED: "JA-101",
  MICROPHONE_NOT_AVAILABLE: "JA-102",
  MICROPHONE_MUTED: "JA-103",

  WEBCAM_NOT_ALLOWED: "JV-101",
  WEBCAM_NOT_AVAILABLE: "JV-102",
  WEBCAM_MUTED: "JV-103",
  UNKNOWN_ERROR: "UE-101",
  UNKNOWN_ERROR_CONNECT: "UE-102",

  // all set, how ever we have to check set a code to maintain the functionality flow
  ALL_SET: "ALL_SET",
  WAITING_DEVICE: "VD-101",
  SUBSCRIPTION: "RS-101",
  BASIC_SUBSCRIPTION: "RS-102"
};

// Only working keys are copied from the above INFO_CODE
// those keys which are not used are ignored
export const E_CODE_MAP = {
  "L-101": ct("rta-trmc.eCodeMap.L101"),
  "J-101": ct("rta-trmc.eCodeMap.J101"),
  "J-102": ct("rta-trmc.eCodeMap.J102"),
  "A-101": ct("rta-trmc.eCodeMap.A101"),
  "R-101": ct("rta-trmc.eCodeMap.R101"),
  "I-101": ct("rta-trmc.eCodeMap.I101"),
  "JA-101": ct("rta-trmc.eCodeMap.JA101"),
  "JA-102": ct("rta-trmc.eCodeMap.JA102"),
  "JA-103": ct("rta-trmc.eCodeMap.JA103"),
  "JV-101": ct("rta-trmc.eCodeMap.JV101"),
  "JV-102": ct("rta-trmc.eCodeMap.JV102"),
  "JV-103": ct("rta-trmc.eCodeMap.JV103"),
  "UE-101": ct("rta-trmc.eCodeMap.UE101"),
  "UE-102": ct("rta-trmc.eCodeMap.UE102"),
  "ALL_SET": ct("rta-trmc.eCodeMap.AllSet"),
  "VD-101": ct("rta-trmc.eCodeMap.VD101"),
  "RS-101": ct("rta-trmc.eCodeMap.RS101"),
  "RS-102": ct("rta-trmc.eCodeMap.RS102"),
}

export const INFO_CODE_LIST = {
  L_STEP: "L-101",
  L_STEP_A_Y_N_BTN: "L-102",

  L_STEP_A_NO: "L-103",
  L_STEP_A_NO_YES: "L-104",
  L_STEP_A_NO_NO: "L-105",

  L_STEP_A_YES: "L-106",
  L_STEP_A_YES_A: "L-107",
  L_STEP_A_YES_A_YES_W: "L-108",
  L_STEP_A_YES_A_YES_W_SUBMIT: "L-109",

  L_STEP_A_YES_B: "L-110",
  L_STEP_A_YES_B_YES: "L-111",
  L_STEP_A_YES_B_YES_W: "L-112",
  L_STEP_A_YES_B_YES_W_SUBMIT: "L-113",

  L_STEP_A_YES_B_NO: "L-114",

  L_STEP_A_YES_C: "L-115",
  L_STEP_A_YES_C_YES: "L-116",
  L_STEP_A_YES_C_YES_W: "L-116",

  L_STEP_A_YES_C_NO: "L-117",

  P_STEP: "I-101",
  P_STEP_YES: "I-102",
  P_STEP_NO: "I-103",

  A_STEP: "A-101",
  A_STEP_YES: "A-102",
  A_STEP_NO: "A-103",

  R_AD_N_ALD: "JA-101",
  R_AD_N_AWL: "JA-102",
  R_AD_N_MUTE: "JA-103",

  R_VD_N_ALD: "JV-101",
  R_VD_N_AWL: "JV-102",
  R_VD_N_MUTE: "JV-103",

  UNKNOWN_ERROR: "UE-101",
  UNKNOWN_ERROR_CONNECT: "UE-102",

  DEVICE_WAITING: "WD-101",

  PREM_SUBS: "RS-101",
  BASIC_SUBS: "RS-102",
}

export const WAITING_TIME = {
  DEFAULT: 60,
  FINAL_WAITING: 150,
  INTERFACE_WAITING: 90,
  PORT_WAITING: 90,
  BUFFER_TIMER: 120,
  LIGHT_ON_TIMER: 90,
  FIREWALL_WAITING: 60,
  CONNECT_EXPIRE: 120,
  SOCKET_WAIT_EXPIRE: 110000,
  DEVICE_PROGRESS_TIME: 3000,
  DEVICE_PROGRESS_TIME_AFTER: 2000
};

export const systemBootMessage = {
  REINIT_SYSTEM: "REINIT_SYSTEM",
  DETECT_DEVICE: "DETECT_DEVICE",
  ALL_SET: "ALL_SET",
  JOIN_MEETING: "JOIN_MEETING",
  AUDIO: "AUDIO",
  VIDEO: "VIDEO",
  WAITING_EXPIRE: "WAITING_EXPIRE",
  SUBSCRIPTION_SHOW: "SUBSCRIPTION_SHOW",
  SUBSCRIPTION_SHOW_BASIC: "SUBSCRIPTION_SHOW_BASIC",
  DEVICE_RECHECK: "DEVICE_RECHECK"
};

export const HELP_INFO = {
  SUPPORT_LINK: "https://realtimeaudio.com/support/"
};

export const DEVICE_INFO_MESSAGES_KEYS = {
  CHECK_DEVICE_INTERNET: "CHECK_DEVICE_INTERNET",
  CHECK_DEVICE: "CHECK_DEVICE",
  CHECK_INTERNET: "CHECK_INTERNET",
  CHECK_INTERFACE: "CHECK_INTERFACE",
  CHECK_COMPATIBLE: "CHECK_COMPATIBLE",
  CHECK_SUBSCRIPTION: "CHECK_SUBSCRIPTION"
};

export const RUNNING_PROCESS_TIGGER_POINT = {
  DEVICE_PAIRING: "DEVICE_PAIRING",
  DEVICE_NOT_ERROR_WAITING: "DEVICE_NOT_ERROR_WAITING",
  DETECT_INITIAL_DEVICE: "DETECT_INITIAL_DEVICE",
  DEVICE_HAS_ERROR: "DEVICE_HAS_ERROR",
  INTERFACE_ERROR: "INTERFACE_ERROR",
  PORT_ERROR: "PORT_ERROR",
  NO_DEVICE_DETECT: "NO_DEVICE_DETECT"
};

export const DEVICE_DETECT_STEP = {
  // "status": false,
  loading: true,
  success: false,
  failed: false,
  check_message: "rta-trmc.premeeting.deviceDetectStep.checkMessage",
  success_message: "rta-trmc.premeeting.deviceDetectStep.successMessage",
  infoCode: INFO_CODE.NO_DEVICE_DETECT,
  failed_message: "rta-trmc.premeeting.deviceDetectStep.failedMessage",
};

export const DEVICE_INFO_MESSAGES = {
  [DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET]: {
    infoCode: INFO_CODE.NO_DEVICE_DETECT,
    // "status": false,
    loading: true,
    success: false,
    failed: false,
    check_message: "rta-trmc.premeeting.checkDevicInternet.checkMessage",
    success_message: "rta-trmc.premeeting.checkDevicInternet.successMessage",
    failed_message: "rta-trmc.premeeting.checkDevicInternet.failedMessage",
  },

  [DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE]: {
    infoCode: INFO_CODE.NO_DEVICE_DETECT,
    // "status": false,
    loading: true,
    success: false,
    failed: false,
    check_message: "rta-trmc.premeeting.checkDevice.checkMessage",
    success_message: "rta-trmc.premeeting.checkDevice.successMessage",
    failed_message: "rta-trmc.premeeting.checkDevice.failedMessage",
  },
  [DEVICE_INFO_MESSAGES_KEYS.CHECK_INTERNET]: {
    infoCode: INFO_CODE.SYMMETRIC_NAT,
    // "status": false,
    loading: true,
    success: false,
    failed: false,
    check_message: "rta-trmc.premeeting.checkInternet.checkMessage",
    success_message: "rta-trmc.premeeting.checkInternet.successMessage",
    failed_message: "rta-trmc.premeeting.checkInternet.failedMessage",
  },
  [DEVICE_INFO_MESSAGES_KEYS.CHECK_INTERFACE]: {
    infoCode: INFO_CODE.NO_INTER,
    // "status": false,
    loading: true,
    success: false,
    failed: false,
    check_message: "rta-trmc.premeeting.checkInterface.checkMessage",
    success_message: "rta-trmc.premeeting.checkInterface.successMessage",
    failed_message: "rta-trmc.premeeting.checkInterface.failedMessage",
  },
  [DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE]: {
    infoCode: INFO_CODE.UNKNOWN_ERROR_CONNECT,
    waitingCode: INFO_CODE.WAITING_DEVICE,
    // "status": false,
    loading: true,
    success: false,
    failed: false,
    check_message: "rta-trmc.premeeting.checkCompatible.checkMessage",
    success_message: "rta-trmc.premeeting.checkCompatible.successMessage",
    failed_message: "rta-trmc.premeeting.checkCompatible.failedMessage",
  },
  [DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION]: {
    infoCode: INFO_CODE.SUBSCRIPTION,
    // "status": false,
    loading: true,
    success: false,
    failed: false,
    check_message: "rta-trmc.premeeting.checkSubscription.checkMessage",
    success_message: "rta-trmc.premeeting.checkSubscription.successMessage",
    failed_message: "rta-trmc.premeeting.checkSubscription.failedMessage",
  }
};

// A-101 no interface
// N-101 no compatible interface
// L-101 no device found

export const deviceGuide = {
  subscription: {
    title: "rta-trmc.premeeting.basicSubscriptionNot",
    // "description": "An active RealTime Audio device subscription was NOT found for this user account. Please make sure that you are logged in as a user with an active subscription or click the link below to activate your RealTime Audio device.<br/><br/>Choose and click on the text below to activate your subscription or to continue without ultra-low latency.",
    description: "rta-trmc.premeeting.subscription.description",
    bottom_title: "rta-trmc.premeeting.subscription.bottomTitle",
    askLogin: true,
    checklist: [
      {
        title: "rta-trmc.premeeting.subscription.checklistTitleOne",
        link: systemBootMessage.SUBSCRIPTION_SHOW
      },
      {
        check_basic_subscription: true,
        title: "rta-trmc.premeeting.subscription.checklistTitleTwo",
        chainVal: deviceCodeChain.BASIC_SUBSCRIPTION,
        nextLink: systemBootMessage.SUBSCRIPTION_SHOW_BASIC,
        check_is_guest_user: true
      }
    ],
    info_code: INFO_CODE_LIST.PREM_SUBS
  },
  basic_subscription: {
    title: "rta-trmc.premeeting.basicSubscriptionNot",
    // "description": "An active RealTime Audio device subscription was NOT found for this user account. Please make sure that you are logged in as a user with an active subscription or click the link below to activate your RealTime Audio device.<br/><br/>Choose and click on the text below to activate your subscription or to continue without ultra-low latency.",
    description: "rta-trmc.premeeting.basicSubscription.description",
    bottom_title: "rta-trmc.premeeting.basicSubscription.bottomTitle",
    askLogin: true,
    checklist: [
      {
        title: "rta-trmc.premeeting.basicSubscription.checklistTitleOne",
        link: systemBootMessage.SUBSCRIPTION_SHOW,
        checkDeviceConnected: true
      },
      // START : Need to make it configurable based on pre-meting in conference
      // {
      //   title: "Continue with ultra-low latency",
      //   link: systemBootMessage.DEVICE_RECHECK,
      //   will_check_box: true
      // }
      // END : Need to make it configurable based on pre-meting in conference
    ],
    info_code: INFO_CODE_LIST.BASIC_SUBS
  },
  primary_link: [
    {
      button: {
        description: "rta-trmc.premeeting.primaryLink.buttonOneDescription",
        class: "font18"
      }
    },
    {
      button: {
        title: "rta-trmc.premeeting.primaryLink.buttonTwoTitle",
        // will_join: true
        next_move: systemBootMessage.SUBSCRIPTION_SHOW_BASIC
      }
    },
    {
      button: {
        title: "rta-trmc.premeeting.primaryLink.buttonThreeTitle"
      }
    },
    {
      button: {
        title: "rta-trmc.premeeting.primaryLink.buttonFourTitle",
        link:
          "https://taylor-robinson-music-instruments9.mybigcommerce.com/realtime-audio-box-plug-plug-and-play-solution-4gb/"
      }
    },
    {
      button: {
        title: "rta-trmc.premeeting.primaryLink.buttonFiveTitle",
        link: "https://realtimeaudio.com/hardware/"
      }
    },
    {
      info_code: INFO_CODE_LIST.L_STEP
    }
  ],
  unknown_error: {
    description: "rta-trmc.premeeting.unknownError.description",
    checklist: [
      {
        title: "rta-trmc.premeeting.unknownError.checklistTitleOne",
        // "link": systemBootMessage.JOIN_MEETING
        will_join: true
      },
      {
        title: "rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle",
        link: "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQZGJGYJ2D9Y389SD82MW06"
      },
      {
        title: "rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle",
        contact: {
          zendesk: {
            support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
            info_code: ""
          },
          info_code: INFO_CODE_LIST.UNKNOWN_ERROR
        }
      }
    ]
  },
  unknown_error_connect: {
    // description: "Unknown error, we are unable to pair your device",
    description: "rta-trmc.premeeting.unknownErrorConnect.description",
    checklist: [
      {
        title: "rta-trmc.premeeting.unknownErrorConnect.checklistTitleOne",
        // "link": systemBootMessage.JOIN_MEETING
        will_join: true
      },
      {
        title: "rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle",
        link: "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQR17H857E1P63CB6V1XFV9V"
      },
      {
        title: "rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle",
        contact: {
          zendesk: {
            support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
            info_code: ""
          },
          info_code: INFO_CODE_LIST.UNKNOWN_ERROR_CONNECT
        }
      }
    ]
  },
  // unknown_error_connect: {
  //     title:
  //       "Your audio interface does not seem to be compatible with your RealTime Audio device.",
  //     title_b: "Please check....",
  //     checklist: [
  //       'That your audio interface is "class compliant". This means that it is plug-and-play and does not require any program or application in order to be setup or run.',
  //       "That your audio interface is capable of transmitting in 48kHz with 64 buffer size.",
  //       {
  //         title : "That your audio interface can be found on this list of tested and approved devices.",
  //         link : "https://support.realtimeaudio.com/hc/en-us/articles/12352584487195"
  //       }
  //     ],
  //     bottom_title:
  //       "<p class='color-black-tree text-center mt-3'>Once confirmed, click below to try again</p>",

  //     confirmation: true,
  //     option: {
  //       yes: {
  //         button: {
  //           title: "All three above are true"
  //         },
  //         waiting: {
  //           title:
  //             "Please wait while we are checking again audio interface",
  //           show_timer: true,
  //           show_error: true,
  //           timer: WAITING_TIME.INTERFACE_WAITING
  //         }
  //       },
  //       contact: {
  //         zendesk: {
  //           support: "zen desk",
  //           info_code: ""
  //         },
  //         link:
  //           "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQR17H857E1P63CB6V1XFV9V"
  //       }
  //     },
  //     confirm_title: "All three above are"
  // },
  webcam: {
    not_allowed: {
      description: "rta-trmc.premeeting.webcamNotAllowed.description",
      checklist: [
        //     {
        //     "title": "Click here when done to reboot.",
        //     "link": systemBootMessage.REINIT_SYSTEM
        // },

        {
          title: "rta-trmc.premeeting.joinWithoutVideo",
          link: systemBootMessage.DETECT_DEVICE
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle",
          link:
            "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059-RealTime-Audio-Webcam-Best-Practices-and-Troubleshooting-Guide#h_01G9N281RWBT2GBNZF7B4P7K5V"
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle",
          contact: {
            zendesk: {
              support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
              info_code: ""
            },
          }
        }
      ],
      info_code: INFO_CODE_LIST.R_VD_N_ALD

    },
    muted: {
      // "description": infoMessages.videoMuted + " You can unmute your camera on click on crossing camera icon above.",
      description: "rta-trmc.premeeting.videoMuted" + ":ICON-unmute-video",
      checklist: [
        {
          title: "rta-trmc.premeeting.joinWithoutVideo",
          link: systemBootMessage.DETECT_DEVICE
        },
        // {
        //   title: "Troubleshoot",
        //   link: "https://realtimeaudio.com"
        // },
        // {
        //   title: "Contact Support",
        //   contact: {
        //     zendesk: {
        //       support: "zen desk",
        //       info_code: ""
        //     }
        //   }
        // }
      ],
      info_code: INFO_CODE_LIST.R_VD_N_MUTE
    },

    not_available: {
      title: "rta-trmc.premeeting.webcamNotAvailable.title",
      description: "rta-trmc.premeeting.webcamNotAvailable.description",
      checklist: [
        //     {
        //     "title": "Click here when done to reboot.",
        //     "link": systemBootMessage.REINIT_SYSTEM
        // },

        {
          title: "rta-trmc.premeeting.joinWithoutVideo",
          link: systemBootMessage.DETECT_DEVICE
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle",
          link:
            "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQWYVQEHPK63GF1CN148SHC"
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle",
          contact: {
            zendesk: {
              support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
              info_code: ""
            },
          }
        }
      ],
      info_code: INFO_CODE_LIST.R_VD_N_AWL
    }
  },
  microphone: {
    not_allowed: {
      description: "rta-trmc.premeeting.microphoneNotAllowed.description",
      checklist: [
        //     {
        //     "title": "Click here when done to reboot.",
        //     "link": systemBootMessage.REINIT_SYSTEM
        // },

        {
          title: "rta-trmc.premeeting.joinWithoutAudio",
          link: systemBootMessage.ALL_SET
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle",
          link:
            "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01G9N281RWBT2GBNZF7B4P7K5V"
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle",
          contact: {
            zendesk: {
              support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
              info_code: ""
            },
          }
        }
      ],
      info_code: INFO_CODE_LIST.R_AD_N_ALD
    },
    muted: {
      // "description": infoMessages.audioMuted + " You can unmute your microphone on click on crossing microphone icon above.",
      description: "rta-trmc.premeeting.audioMuted",
      checklist: [
        {
          title: "rta-trmc.premeeting.joinWithoutAudio",
          link: systemBootMessage.ALL_SET
        },
        // {
        //   title: "Troubleshoot",
        //   link: "https://realtimeaudio.com"
        // },
        // {
        //   title: "Contact Support",
        //   contact: {
        //     zendesk: {
        //       support: "zen desk",
        //       info_code: ""
        //     }
        //   }
        // }
      ],
      info_code: INFO_CODE_LIST.R_AD_N_MUTE
    },
    not_available: {
      title: "rta-trmc.premeeting.microphoneNotAvailable.title",
      description: "rta-trmc.premeeting.microphoneNotAvailable.description",
      checklist: [
        //     {
        //     "title": "Click here when done to reboot.",
        //     "link": systemBootMessage.REINIT_SYSTEM
        // },

        {
          title: "rta-trmc.premeeting.joinWithoutAudio",
          link: systemBootMessage.ALL_SET
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle",
          link:
            "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQWYVQEHPK63GF1CN148SHC"
        },
        {
          title: "rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle",
          contact: {
            zendesk: {
              support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
              info_code: ""
            },
            info_code: INFO_CODE_LIST.R_AD_N_ALD
          }
        }
      ]
    }
  },
  all_set: {
    // title: '"All set!"',
    description: "rta-trmc.premeeting.allSet.description",
    will_join: true
  },
  socket_no_error_waiting: {
    waiting: {
      title: "rta-trmc.premeeting.socketNoErrorWaiting.waitingTitle",
      show_timer: true,
      show_error: true,
      timer: WAITING_TIME.FINAL_WAITING
    },
    info_code: INFO_CODE_LIST.DEVICE_WAITING
  },
  light_on: {
    title: "rta-trmc.premeeting.lightOn.title",
    title_b: "rta-trmc.premeeting.lightOn.titleB",
    yes: {
      role: "rta-trmc.premeeting.lightOn.yes.role",
      title: "rta-trmc.premeeting.lightOn.yes.title",
      description: "rta-trmc.premeeting.lightOn.yes.description",
      bottom_title: "rta-trmc.premeeting.lightOn.yes.bottomTitle",
      option: {
        button: {
          step_a: {
            title: "rta-trmc.premeeting.lightOn.yes.option.buttonStepATitle",
            image: ""
          },
          step_b: {
            title: "rta-trmc.premeeting.lightOn.yes.option.buttonStepBTitle",
            image: ""
          },
          step_c: {
            title: "rta-trmc.premeeting.lightOn.yes.option.buttonStepCTitle",
            image: ""
          }
        },
        step_a: {
          port_issue: {
            yes: {
              description: {
                title: "rta-trmc.premeeting.lightOn.yes.option.stepA.descriptionTitle",
                link:
                  "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQMQNZ4TEYFG64XGEMJFGETX"
              },
              bottom_title: "rta-trmc.premeeting.lightOn.yes.option.stepA.bottomTitle",
              option: {
                yes: {
                  button: {
                    title: "rta-trmc.premeeting.lightOn.yes.option.stepA.yes.buttonTitle",
                  },
                  waiting: {
                    title: "rta-trmc.premeeting.lightOn.yes.option.stepA.yes.waitingTitle",
                    show_timer: true,
                    show_error: true,
                    timer: WAITING_TIME.PORT_WAITING,
                    info_code: INFO_CODE_LIST.P_STEP_YES
                  }
                },
                no: {
                  button: {
                    title: "rta-trmc.premeeting.lightOn.yes.option.stepA.no.buttonTitle",
                  },
                  need_help: {
                    title: "rta-trmc.premeeting.lightOn.yes.option.stepA.no.needHelpTitle",
                    contact: {
                      zendesk: {
                        support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                        info_code: ""
                      },
                      link:
                        "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQMQNZ4TEYFG64XGEMJFGETX"
                    },
                    info_code: INFO_CODE_LIST.P_STEP_NO
                  },

                }
              },
              info_code: INFO_CODE_LIST.P_STEP
            },
            no: {
              non_premissive_net: {
                yes: {
                  title: "rta-trmc.premeeting.nonPremissiveNet.yes.title",
                  description: "rta-trmc.premeeting.nonPremissiveNet.yes.description",
                  option: {
                    need_help: {
                      contact: {
                        zendesk: {
                          support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                          info_code: ""
                        },
                        link: "https://realtimeaudio.com"
                      }
                    },
                    will_join: true
                  }
                },
                unknown: {
                  title: "rta-trmc.premeeting.nonPremissiveNet.unknown.title",
                  option: {
                    need_help: {
                      contact: {
                        support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                        info_code: ""
                      },
                      link:
                        "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQZGJGYJ2D9Y389SD82MW06"
                    },
                    will_join: true
                  }
                },
                no: {
                  detecting_device: {
                    found_device: {
                      my_device: {
                        yes: {
                          checking_interface: {
                            yes: {
                              title: "rta-trmc.premeeting.checkingInterface.yes.title",
                              buffer_issue: {
                                yes: {
                                  title: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueYes.title",
                                  description: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueYes.description",
                                  show_timer: true,
                                  show_error: true,
                                  timer: WAITING_TIME.BUFFER_TIMER,
                                  option: {
                                    yes: {
                                      title:
                                        "rta-trmc.premeeting.checkingInterface.yes.bufferIssueYes.optionYesTitle",
                                      will_connect: true
                                    },
                                    no: {}
                                  }
                                },
                                no: {
                                  title: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.title",
                                  title_b: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.titleB",
                                  checklist: [
                                    "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.checkList.first",
                                    "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.checkList.second",
                                    "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.checkList.third",
                                  ],
                                  bottom_title: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.bottomTitle",

                                  confirmation: true,
                                  option: {
                                    yes: {
                                      button: {
                                        title: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.buttonTitle",
                                      },
                                      waiting: {
                                        title: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.waitingTitle",
                                        show_timer: true,
                                        show_error: true,
                                        timer: WAITING_TIME.INTERFACE_WAITING
                                      }
                                    },
                                    contact: {
                                      zendesk: {
                                        support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                                        info_code: ""
                                      },
                                      link:
                                        "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQR17H857E1P63CB6V1XFV9V"
                                    }
                                  },
                                  confirm_title: "rta-trmc.premeeting.checkingInterface.yes.bufferIssueNo.confirmTitle",
                                  // need_help: {
                                  //   contact: {
                                  //     zendesk: {
                                  //       support: "zen desk",
                                  //       info_code: ""
                                  //     },
                                  //     link:
                                  //       "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQR17H857E1P63CB6V1XFV9V",
                                  //     doc_link:
                                  //       "https://support.realtimeaudio.com/hc/en-us/articles/12352584487195"
                                  //   }
                                  // }
                                }
                              }
                            },
                            no: {
                              title: "rta-trmc.premeeting.checkingInterface.no.title",
                              title_b: "rta-trmc.premeeting.checkingInterface.no.titleB",
                              checklist: [
                                "rta-trmc.premeeting.checkingInterface.no.checklist.first",
                                "rta-trmc.premeeting.checkingInterface.no.checklist.second",
                                "rta-trmc.premeeting.checkingInterface.no.checklist.third",
                                "rta-trmc.premeeting.checkingInterface.no.checklist.fourth",
                              ],
                              bottom_title: "rta-trmc.premeeting.checkingInterface.no.bottomTitle",
                              option: {
                                yes: {
                                  button: {
                                    title: "rta-trmc.premeeting.checkingInterface.no.option.yes.titleFirst"
                                  },
                                  waiting: {
                                    title: "rta-trmc.premeeting.checkingInterface.no.option.yes.titleSecond",
                                    show_timer: true,
                                    show_error: true,
                                    timer: WAITING_TIME.BUFFER_TIMER,
                                    info_code: INFO_CODE_LIST.A_STEP_YES
                                  }
                                },
                                no: {
                                  button: {
                                    title:
                                      "rta-trmc.premeeting.checkingInterface.no.option.no.titleFirst"
                                  },
                                  need_help: {
                                    title:
                                      "rta-trmc.premeeting.checkingInterface.no.option.no.titleSecond",
                                    contact: {
                                      zendesk: {
                                        support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                                        info_code: ""
                                      },
                                      link: "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQR03N468S1VQXQA9FMYHR8P",
                                      info_code: INFO_CODE_LIST.A_STEP_NO
                                    }
                                  },
                                }
                              },
                              info_code: INFO_CODE_LIST.A_STEP
                            }
                          }
                        },
                        no: {
                          register_device: {
                            yes: {
                              title: "rta-trmc.premeeting.registerDevice.yes.title",
                              show_timer: true,
                              show_error: true,
                              timer: WAITING_TIME.LIGHT_ON_TIMER,
                              next_wait: {
                                title: "rta-trmc.premeeting.registerDevice.yes.nextWait.title",
                                description: "rta-trmc.premeeting.registerDevice.yes.nextWait.description",
                                bottom_title: "rta-trmc.premeeting.registerDevice.yes.nextWait.bottomTitle",
                                option: {
                                  yes: {
                                    button: {
                                      title: "Translate.buttonTitle.yesSmall"
                                    },
                                    waiting: {
                                      title: "rta-trmc.premeeting.registerDevice.yes.nextWait.waitingTitle",
                                      description: "rta-trmc.premeeting.registerDevice.yes.nextWait.waitingDescription",
                                      description_b: "rta-trmc.premeeting.registerDevice.yes.nextWait.waitingDescriptionB",
                                      input_box: true,
                                      contact: {
                                        zendesk: {
                                          support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                                          info_code: ""
                                        },
                                        link: "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQN89FSKZV9SHP9TT8HNW63K",
                                        info_code: INFO_CODE_LIST.L_STEP_A_YES_A_YES_W_SUBMIT
                                      },
                                    }
                                  },
                                  no: {
                                    button: {
                                      title: "Translate.buttonTitle.noSmall"
                                    },
                                    need_help: {
                                      title: "rta-trmc.premeeting.registerDevice.yes.nextWait.needHelpTitle",
                                      contact: {
                                        zendesk: {
                                          support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                                          info_code: ""
                                        },
                                        link:
                                          "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQN89FSKZV9SHP9TT8HNW63K",
                                        info_code: INFO_CODE_LIST.L_STEP_A_YES_A_YES_W
                                      }
                                    }
                                  }
                                }
                              },
                              info_code: INFO_CODE_LIST.L_STEP_A_YES_A_YES_W

                              // "option": {
                              //     "yes": {
                              //         "waiting": {
                              //             "title": "Please wait while we are checking the system."
                              //         }
                              //     },
                              // },
                              // "need_help": {
                              // "contact": {
                              //     "zendesk": {
                              //         "support": "zen desk",
                              //         "info_code": "",
                              //     },
                              //     "link": "https://realtimeaudio.com"
                              // },
                              // }
                            },
                            no: {
                              description: "rta-trmc.premeeting.registerDevice.no.description",
                              input_submit: true
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        step_b: {
          title: "rta-trmc.premeeting.stepB.title",
          checklist: [
            "rta-trmc.premeeting.stepB.checklist.first",
            "rta-trmc.premeeting.stepB.checklist.second",
            "rta-trmc.premeeting.stepB.checklist.third",
          ],
          bottom_title: "rta-trmc.premeeting.stepB.bottomTitle",
          option: {
            yes: {
              button: {
                title: "rta-trmc.premeeting.stepB.option.yes.buttonTitle",
                title_b: "rta-trmc.premeeting.stepB.option.yes.buttonTitleB",
              },
              waiting: {
                // "title": "Please wait, while we are checking the system. There should now be both a yellow AND green light blinking by the ethernet port on your RTA device.",
                title: "rta-trmc.premeeting.stepB.option.yes.waitingTitle",
                show_timer: true,
                show_error: true,
                timer: WAITING_TIME.FIREWALL_WAITING,
                info_code: INFO_CODE_LIST.L_STEP_A_YES_B_YES_W
              },
              info_code: INFO_CODE_LIST.L_STEP_A_YES_B_YES
            },
            no: {
              button: {
                title: "rta-trmc.premeeting.stepB.option.no.buttonTitle"
              },
              need_help: {
                title: "rta-trmc.premeeting.stepB.option.no.needHelpTitle",
                contact: {
                  zendesk: {
                    support: "rta-trmc.premeeting.stepB.option.no.zenDeskMesh",
                    info_code: ""
                  },
                  link:
                    "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQZ2HY9J77WNT8WT64E893M",
                  firewall_link:
                    "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01G9N2D0XQMYS1RN3FSVH2XPG3",
                  mesh_link:
                    "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQT233K7S24H2F4213NZ8AK",
                  info_code: INFO_CODE_LIST.L_STEP_A_YES_B_YES
                },
              },

            }
          },
          info_code: INFO_CODE_LIST.L_STEP_A_YES_B
        },
        step_c: {
          title: "rta-trmc.premeeting.stepC.title",
          title_b: "rta-trmc.premeeting.stepC.titleB",
          checklist: [
            "rta-trmc.premeeting.stepC.checklist.first",
            "rta-trmc.premeeting.stepC.checklist.second",
          ],
          bottom_title:
            "rta-trmc.premeeting.stepC.bottomTitle",
          confirmation: true,
          option: {
            yes: {
              button: {
                title: "rta-trmc.premeeting.stepC.option.yes.buttonTitle"
              },
              waiting: {
                title: "rta-trmc.premeeting.stepC.option.yes.waitingTitle",
                show_timer: true,
                show_error: true,
                timer: WAITING_TIME.LIGHT_ON_TIMER,
                info_code: INFO_CODE_LIST.L_STEP_A_YES_C_YES_W
              },
              info_code: INFO_CODE_LIST.L_STEP_A_YES_C_YES
            },
            no: {
              button: {
                title: "rta-trmc.premeeting.stepC.option.no.buttonTitle"
              },
              need_help: {
                title: "rta-trmc.premeeting.stepC.option.no.needHelpTitle",
                contact: {
                  zendesk: {
                    support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                    info_code: ""
                  },
                  link:
                    "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQZ2HY9J77WNT8WT64E893M",
                  info_code: INFO_CODE_LIST.L_STEP_A_YES_C_NO
                }
              },
            }
          },
          info_code: INFO_CODE_LIST.L_STEP_A_YES_C
        }
      },
      info_code: INFO_CODE_LIST.L_STEP_A_YES
    },
    no: {
      title: "rta-trmc.premeeting.lightOn.no.title",
      checklist: [
        "rta-trmc.premeeting.lightOn.no.checklist.first",
        "rta-trmc.premeeting.lightOn.no.checklist.second",
        "rta-trmc.premeeting.lightOn.no.checklist.third",
        "rta-trmc.premeeting.lightOn.no.checklist.fourth",
      ],
      bottom_title:
        "rta-trmc.premeeting.lightOn.no.bottomTitle",
      checkbox: true,
      option: {
        yes: {
          button: {
            title: "rta-trmc.premeeting.lightOn.no.option.yes.buttonTitle"
          },
          nextLink: [...deviceCodeChain.DEFAULT, "yes"],
          waiting: {
            title: "rta-trmc.premeeting.lightOn.no.option.yes.waitingTitle",
            show_timer: true,
            show_error: true,
            timer: WAITING_TIME.LIGHT_ON_TIMER,
            info_code: INFO_CODE_LIST.L_STEP_A_YES_B_YES_W

          },
          info_code: INFO_CODE_LIST.L_STEP_A_NO_YES
        },
        no: {
          button: {
            title: "rta-trmc.premeeting.lightOn.no.option.no.buttonTitle"
          },
          need_help: {
            title:
              "rta-trmc.premeeting.lightOn.no.option.no.needHelpTitle",
            contact: {
              zendesk: {
                support: "rta-trmc.premeeting.webcamNotAvailable.contactSupportZenDesk",
                info_code: ""
              },
              link:
                "https://support.realtimeaudio.com/hc/en-us/articles/7844320380059#h_01GQQS88XSMQQH6F4WRMHC3XHQ",
              info_code: INFO_CODE_LIST.L_STEP_A_NO_NO
            }
          },
        },
      },
      info_code: INFO_CODE_LIST.L_STEP_A_NO
    },
    info_code: INFO_CODE_LIST.L_STEP_A_Y_N_BTN
  }
};
